<div class="tailing-icon-table-cell">
  <span
    class="tailing-icon-table-cell__text"
    qimaAutoTooltip
    [qimaAutoTooltipStyle]="qimaTooltip.style.DARK"
    [qimaAutoTooltipPosition]="qimaTooltip.position.TOP"
    [qimaAutoTooltipText]="data.text"
    [qimaAutoTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
    [qimaAutoTooltipHasArrow]="true"
  >
    {{ data.text }}
  </span>

  <!-- TODO: Wait for the backend to finish adding the fields -->
  @if (false) {
    <qima-icon
      class="tailing-icon-table-cell__icon"
      qimaTooltip
      [qimaTooltipText]="'PAYMENTS.PENDING_VALIDATION_TIP' | translate"
      [qimaTooltipHasArrow]="true"
      [qimaTooltipPosition]="qimaTooltip.position.TOP"
      [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
      [qimaTooltipStyle]="qimaTooltip.style.DARK"
      [qimaIconName]="qimaIcon.iconName.INFO"
      [qimaIconSize]="qimaIcon.sizeMedium"
      [style.color]="qimaColor.pool.POOL_500"
    ></qima-icon>
  }
</div>
